import {ISnackbarData, TMessage} from "../../index";
import {SNACKBAR_DURATION_MEDIUM} from "../../constants";
import * as ko from "knockout";
import snackbar_dialogHtml from './snackbar-dialog.html?raw';

export let template: string = snackbar_dialogHtml;

export class viewModel {

    private readonly duration: KnockoutObservable<number | null> = ko.observable(null);
    private readonly message: KnockoutObservable<TMessage | null> = ko.observable(null);
    private readonly obs: KnockoutObservable<ISnackbarData>;

    private dur: number | null = null;
    private timeStart: number | null = null;
    private timeoutId: ReturnType<typeof setTimeout> | null = null;

    private readonly isShown: KnockoutObservable<boolean | null> = ko.observable(null)
    private readonly isPaused: KnockoutObservable<boolean | null> = ko.observable(null)

    constructor(private params: { observable: KnockoutObservable<ISnackbarData> }) {
        this.obs = params.observable;
        this.obs.subscribe((newVal: ISnackbarData) => {
            this.setMessage(newVal?.message, newVal?.duration);
        });
        if (this.obs()) {
            this.setMessage(this.obs().message, this.obs().duration);
        }
    }

    private setMessage(message: TMessage | null, duration: number = SNACKBAR_DURATION_MEDIUM) {
        this.isShown(false)
        this.timeStart = new Date().getTime();
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        if (message) {
            this.message(message);
            this.timeoutId = setTimeout(() => {
                this.setMessage(null)
            }, duration);
            this.duration(null)
            this.duration(duration);
            this.dur = duration;
            this.isShown(true);
            this.isPaused(false)
        } else {
            clearTimeout(this.timeoutId ?? undefined);
            this.timeoutId = setTimeout(() => {
                this.message(null)
            }, 200)
            this.isShown(false);
            this.duration(null);
            this.dur = null;
        }
    }

    wrapperClasses = ko.pureComputed(() => {
        let ret = ["snackbarDialog__wrapper"];
        const obs = this.obs();
        if (obs?.type) {
            ret.push(obs.type)
        }
        return ret.join(" ");
    });

    onMouseOver() {
        if (this.dur == null || this.timeStart == null) {
            return;
        }
        this.dur = this.dur - (new Date().getTime() - this.timeStart);
        this.timeStart = null;
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = null;
        this.isPaused(true)
    }

    onMouseOut() {
        this.isPaused(false)
        this.timeStart = new Date().getTime();
        this.timeoutId = setTimeout(() => {
            this.setMessage(null)
        }, this.dur ?? 0);
    }

    onCloseClick() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.setMessage(null)
    }

    onUndoClick() {
        if (this.isShown()) {
            this.setMessage(null, 0);
        }
        this.obs()?.undo?.();
    }

    private getMessage(): string {
        const msg: TMessage | null = this.message();
        if (msg == null) {
            return '';
        }
        if (typeof msg === 'function' && !ko.isObservable(msg)) {
            return msg()
        } else {
            return String(msg)
        }
    }

}